import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from 'app/core/user/user.service';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _httpClient = inject(HttpClient);
    private _userService = inject(UserService);
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                this._applyRoleFilters(navigation);
                this._navigation.next(navigation);
            })
        );
    }

    // Admin > User Management is already enforced server-side (cdm-service's @PreAuthorize) and
    // client-side route-guarded (AdminRoleGuard) -- this just keeps a non-admin from seeing (and
    // clicking into a redirect for) a nav item they could never actually use.
    private _applyRoleFilters(navigation: Navigation): void {
        if (this._userService.hasRole('APP-ADMINISTRATOR')) {
            return;
        }
        navigation.default = navigation.default?.filter((item) => item.id !== 'ADMIN');
    }
}
